module.exports = __webpack_public_path__ + "img/dead-tree-desert-09.cc55afcd.png";